/* ============================================================
   Warenkorb — Rückfrage zu nicht lieferbaren Artikeln.

   Zwei Aufgaben:

   1) Das Telefonnummernfeld nur zeigen und nur dann zur Pflicht machen, wenn die Option
      „telefonische Rücksprache“ gewählt ist. Wichtig ist die Reihenfolge von hidden und
      required: Ein required-Feld, das per hidden unsichtbar ist, blockiert das Absenden,
      ohne dass der Browser die Meldung irgendwo anzeigen könnte — der Kauf wäre dann ohne
      erkennbaren Grund unmöglich. Deshalb wird required IMMER gemeinsam mit der
      Sichtbarkeit gesetzt und entfernt.

   2) Die Prüfung beim Klick auf „Zur Kasse“ mit eigener Rückmeldung statt der
      Browser-Sprechblase.

      Der Weg dorthin ist bewusst das invalid-Ereignis und NICHT ein eigener
      Klick-Abfangjäger am Kasse-Knopf: Der Browser prüft weiterhin selbst und blockiert
      das Absenden auch dann, wenn dieses Skript einmal nicht lädt. preventDefault
      unterdrückt lediglich die Sprechblase — die Sperre bleibt.

      invalid steigt NICHT im DOM auf (kein Bubbling). Die Ereignisse hängen deshalb
      direkt an den Feldern, nicht am Formular.
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    var phoneWrap = root.querySelector('[data-fallback-phone]');
    var phoneInput = phoneWrap ? phoneWrap.querySelector('input') : null;
    var errorEl = root.querySelector('[data-fallback-error]');
    var radios = Array.prototype.slice.call(root.querySelectorAll('input[type="radio"]'));
    if (!phoneWrap || !phoneInput || !errorEl || !radios.length) return;

    function syncPhone() {
      var needsPhone = !!root.querySelector('input[type="radio"][data-requires-phone]:checked');
      phoneWrap.hidden = !needsPhone;
      if (needsPhone) {
        phoneInput.setAttribute('required', 'required');
      } else {
        phoneInput.removeAttribute('required');
      }
    }

    function clearError() {
      root.classList.remove('is-invalid');
      // Der Schein erlischt jetzt hier und nicht mehr nach Ablauf einer Zeit: Er soll
      // stehen bleiben, solange keine Option gewaehlt ist.
      root.classList.remove('is-glowing');
      errorEl.hidden = true;
    }

    function showError(message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
      root.classList.add('is-invalid');

      // Schein neu anlaufen lassen. Eine Animation startet nicht erneut, solange die
      // Klasse schon gesetzt ist — deshalb erst entfernen, dann ein erzwungenes Neu-
      // berechnen des Layouts (offsetWidth lesen), dann wieder setzen.
      root.classList.remove('is-glowing');
      void root.offsetWidth;
      root.classList.add('is-glowing');
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        syncPhone();
        clearError();
      });
      radio.addEventListener('invalid', function (event) {
        event.preventDefault();
        showError('Bitte eine Option wählen.');
      });
    });

    phoneInput.addEventListener('invalid', function (event) {
      event.preventDefault();
      showError('Bitte Telefonnummer angeben.');
    });
    phoneInput.addEventListener('input', function () {
      if (phoneInput.value.trim() !== '') clearError();
    });

    // Frueher raeumte hier ein animationend-Auslauf die Klasse wieder ab — der Schein
    // verloschen also nach sechs Sekunden von selbst, auch wenn weiterhin nichts gewaehlt
    // war. Das ist entfallen: Beendet wird er ausschliesslich in clearError(), also bei
    // der Auswahl einer Option.

    syncPhone();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-fallback]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
